interface hasType {
  type: string;
}

interface hasSize {
  size: number;
}

function isImageFileType<T extends hasType>(file: T) {
  return ['image/jpeg', 'image/gif', 'image/png'].indexOf(file.type) > -1;
}

function isVideoFileType<T extends hasType>(file: T) {
  return file.type.includes('video');
}

function isFileSizeGreaterThanZero<T extends hasSize>(file: T) {
  return file.size > 0;
}

export function isValidFile(file: hasType & hasSize, type: 'image' | 'video') {
  if (!isFileSizeGreaterThanZero(file)) {
    return false;
  }

  if (type === 'image' && !isImageFileType(file)) {
    return false;
  }

  if (type === 'video' && !isVideoFileType(file)) {
    return false;
  }

  return true;
}
